import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Simple bar

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import classnames from "classnames";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useParams } from "react-router-dom";
import Loader from "../../../Components/Common/Loader";
import { useCollaborator } from "../../../hooks/useCollaborators";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function CollaborateursDetail(props) {
  const { t } = props;

  const { id } = useParams();
  const collabQ = useCollaborator(id);

  const collab = collabQ.data || {};
  const profile = collab?.profile || {};
  const userType = collab?.type_collab || profile?.user_type;

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  useEffect(() => {
    document.title = t("Détail Collaborateur");
  }, [t]);

  const error = collabQ.error;
  const errorMessage =
    typeof error === "string" ? error : error?.message || "Erreur";

  if (collabQ.isLoading) return <Loader />;
  if (collabQ.isError) return <Loader error={errorMessage} />;
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={t("Détail Collaborateur")}
          pageTitle={t("Collaborateurs")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                      <div>
                        <div className="d-flex">
                          <img
                            src={profile?.profile_pic}
                            width="100"
                            style={{
                              borderRadius: "50%",
                              height: "100px",
                              width: "100px",
                              objectFit: "cover",
                              objectPosition: "center center",
                              paddingBottom: "10px",
                            }}
                            alt=""
                          />
                          <div
                            style={{
                              marginLeft: "20px",
                              marginTop: "8px",
                            }}
                          >
                            <h2
                              style={{
                                fontWeight: "bold",
                                textTransform: "uppercase",
                              }}
                            >
                              {collab?.username}
                            </h2>
                            {collab?.email}
                            <br />
                            <br></br>
                            {userType === "particular" ? (
                              <h5 className="badge badge-soft-danger">
                                Particulier
                              </h5>
                            ) : userType === "assistant" ? (
                              <h5 className="badge badge-soft-primary">
                                Assistant
                              </h5>
                            ) : userType === "professional" ? (
                              <h5 className="badge badge-soft-info">
                                Professionnel
                              </h5>
                            ) : userType === "expert" ? (
                              <h5 className="badge badge-soft-secondary">
                                Expert
                              </h5>
                            ) : userType === "commite" ? (
                              <h5 className="badge badge-soft-secondary">
                                Commité
                              </h5>
                            ) : userType === "admin" ? (
                              <h5 className="badge badge-soft-secondary">
                                Admin
                              </h5>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="product-content mt-3">
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              {t("Détails")}
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                          activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane id="nav-speci" tabId="1">
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row"> {t("Nom : ")}</th>
                                    <td>
                                      {profile.first_name ||
                                        t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {t("Prénom(s) :")} </th>
                                    <td>
                                      {profile.last_name ||
                                        t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {t("Adresse :")} </th>
                                    <td>
                                      {profile.address || t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {t("Ville :")} </th>
                                    <td>
                                      {profile.city || t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {t("Pays :")} </th>
                                    <td>
                                      {profile.country || t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane id="nav-detail" tabId="2">
                            <div>
                              <h5 className="font-size-16 mb-3">
                                {/* {selectProduct.desigantionProd} */}
                              </h5>
                              <p>{/* {selectProduct.description} */}</p>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

CollaborateursDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(CollaborateursDetail));
